export default "__VITE_ASSET__Cvs7FBGg__"